import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  isSelected: boolean;
  onClick: () => void;
  className?: string;
  children: ReactNode;
  disabled?: boolean;
}

export default function DayButton(props: Props) {
  function onClick(e) {
    e.preventDefault();

    if (props.onClick) {
      props.onClick();
    }
  }

  return (
    <button
      className={tw(
        "relative -ml-px block h-11 flex-1 cursor-pointer border border-borderGray bg-white p-0 outline-none transition hover:relative hover:z-10 hover:border-dark hover:text-organization",
        "first-of-type:ml-0 first-of-type:rounded-l-md first-of-type:before:content-none",
        "last-of-type:rounded-r-md",
        props.isSelected &&
          "before-top-0 border-organization bg-organization text-white before:absolute before:-bottom-px before:-left-px before:-top-px before:w-px before:bg-white before:content-[''] hover:z-0 hover:border-organization hover:text-white",
        props.disabled && "hover:border-borderGray hover:text-dark",
        props.className
      )}
      onClick={onClick}
      disabled={props.disabled}
    >
      <span className={tw(props.disabled && "opacity-20")}>
        {props.children}
      </span>
    </button>
  );
}
